import { render, staticRenderFns } from "./MatingProgram.vue?vue&type=template&id=c62b81ac&scoped=true&"
import script from "./MatingProgram.vue?vue&type=script&lang=js&"
export * from "./MatingProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62b81ac",
  null
  
)

export default component.exports